
export enum RetarderType {
  Hydraulic= 'Hydraulic',
  Electric= 'Electric',
  Absent= 'Absent',

}